const MFG_ARCHIVE_ROLES = [
  "admin",
  "owner",
  "org_admin",
  "org_owner",
  "platform_owner",
  "platform_admin",
  "platform_dev",
] as const;

const MFG_OWNER_DELETE_ROLES = [
  "owner",
  "org_owner",
  "platform_owner",
  "platform_admin",
  "platform_dev",
] as const;

/** Admin (or owner/platform) may archive a named variant. */
export function canArchiveNamedVariant(hasRole: (...roles: string[]) => boolean): boolean {
  return hasRole(...MFG_ARCHIVE_ROLES);
}

/** Owner (or platform) may permanently delete a named variant. */
export function canDeleteNamedVariant(hasRole: (...roles: string[]) => boolean): boolean {
  return hasRole(...MFG_OWNER_DELETE_ROLES);
}
